export enum ContractorsStorageKey {
  ADD_CONTRACTOR_FORM = 'addContractorForm',
}
